<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['view_stock_levels'] == 1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show
                    <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm"
                      :options="Options"></b-form-select>
                    entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter d-flex justify-content-end align-items-center">
                  <label class="d-inline-flex align-items-center me-2">
                    Search:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>


                  <div id="tickets-table_filter" class="ms-2">
                    <export-excel class="btn btn-info" :data="exportData()" name="PRODUCTS.xls">
                      Export <i class="mdi mdi-download"></i>
                    </export-excel>
                  </div>
                </div>


                <div id="tickets-table_filter" class="ms-2">

                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table :items="Items" :fields="Fields" responsive="sm" :per-page="perPage" :current-page="currentPage"
                :filter="filter" :filter-included-fields="filterOn" @filtered="Filtered" :busy="IsBusy"
                class="text-center">
                <template #table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle" type="grow" small></b-spinner>
                    <strong>No Data Found</strong>
                  </div>
                </template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(name)="data">
                  <div>{{ data.item.name }}</div>
                  <small class="text-success fw-bold">{{ data.item.category.name }}</small>
                </template>
                <template #cell(unit)="data">
                  {{ data.item.unit.unit_name }}
                </template>
                <!-- <template #cell(quantity)="data">
                  {{
                    Math.round(
                      data.item.product.quantity / data.item.base_quantity
                    )
                  }}
                </template> -->
                <template #cell(quantities)="data">
                  <div class="row text-center mb-2">
                    <div class="col bg-dark text-light rounded mx-1">Batch</div>
                    <div class="col bg-dark text-light rounded mx-1">
                      Quantity
                    </div>
                    <div class="col bg-dark text-light rounded mx-1">
                      Buy Price
                    </div>
                    <div class="col bg-dark text-light rounded mx-1">
                      Expiry Date
                    </div>
                    <div class="col bg-dark text-light rounded mx-1">
                      Actions
                    </div>
                  </div>
                  <div class="row text-center mb-1" v-for="(quantity, index) in data.item.quantities" :key="index">
                    <div class="col align-items-center">
                      {{ quantity.batch }}
                    </div>
                    <div class="col">{{ quantity.quantity }}</div>
                    <div class="col">UGX. {{ quantity.buying_price }}</div>

                    <div class="col" :class="{
                      'text-info fw-bold': (quantity.expiry_date === null),
                      'text-danger fw-bold': new Date(quantity.expiry_date) < date_today, // Expired drugs
                      'text-warning fw-bold':
                        (new Date(quantity.expiry_date) - date_today) / (1000 * 60 * 60 * 24) <= 30, // About to expire
                    }">
                      <span v-if="new Date(quantity.expiry_date) < date_today" class="text-danger"
                        title="This drug has expired!">
                        <i class="mdi mdi-alert-circle font-size-16"></i>
                      </span>

                      <span v-else-if="(new Date(quantity.expiry_date) - date_today) / (1000 * 60 * 60 * 24) <= 30"
                        class="text-warning" title="This drug is about to expire!">
                        <i class="mdi mdi-alert-circle-outline font-size-16"></i>
                      </span>
                      <span v-else-if="quantity.expiry_date === null" class="text-info" title="Missing Expiry Date!">
                        <i class="mdi mdi-information-outline font-size-16"></i>
                      </span>

                      <!-- <span
                        :title="new Date(quantity.expiry_date) < date_today ? 'This drug has expired!' : 'This drug is about to expire!'" 
                        class="expiry-date"
                      >
                        {{ quantity.expiry_date }}
                      </span> -->
                      <span :title="quantity.expiry_date
                        ? (new Date(quantity.expiry_date) < date_today
                          ? 'This drug has expired!'
                          : ((new Date(quantity.expiry_date) - date_today) / (1000 * 60 * 60 * 24) <= 30
                            ? 'This drug is about to expire!'
                            : 'Expiry date is valid'))
                        : 'Missing expiry date'
                        " :class="{
                          'text-danger': quantity.expiry_date && new Date(quantity.expiry_date) < date_today, // Expired
                          'text-warning':
                            quantity.expiry_date && (new Date(quantity.expiry_date) - date_today) / (1000 * 60 * 60 * 24) <= 30, // About to expire
                          'text-info': !quantity.expiry_date // Missing expiry date
                        }">
                        {{ quantity.expiry_date ? quantity.expiry_date : 'Missing Expiry Date' }}
                      </span>


                    </div>

                    <div class="col">
                      <button v-if="quantity.active == 1" class="btn btn-sm btn-secondary">
                        <b-spinner v-if="loader" small class="mr-1" label="Small Spinner" />
                        <span v-else>Activated</span>
                      </button>
                      <button v-else @click="
                        activateBatch(
                          data.item.id,
                          quantity.id
                        )
                        " class="btn btn-sm btn-primary" :class="{ disabled: loader }">
                        <b-spinner v-if="loader" small class="mr-1" label="Small Spinner" />
                        <span v-else>Activate</span>
                      </button>
                    </div>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br /><br />
            <center>
              <span class="text-primary h6">You have no permission to View Stock Levels</span>
            </center>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { productMethods, productComputed } from "@/state/helpers";
import axios from "axios";
// import * as XLSX from 'xlsx';

export default {
  page: {
    title: "Batch Levels",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Batch Levels",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Batch Levels", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true, tdClass: "align-middle" },
        { key: "id", label: "ID", visible: false },
        {
          key: "name",
          label: "Product",
          visible: true,
          tdClass: "align-middle",
          sortable: true,
        },
        {
          key: "category",
          label: "Category",
          visible: false,
          tdClass: "align-middle",
        },
        {
          key: "quantities",
          label: "Batches",
          visible: true,
          tdClass: "align-middle",
          sortable: true,
        },

      ],
      id: "",
      name: "",
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      date_today: "",
      loader: false,
    };
  },
  computed: {
    ...productComputed,
    List() {
      return this.products.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.products.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.products.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
  },
  mounted() {
    this.initializePage();
    this.fetchProducts();
    this.getDatePart();

    //  this.checkSingleBatchActivation();
    this.TotalRows = this.products.length;
    this.isBusy = false;
  },
  methods: {


    async initializePage() {
      this.isBusy = true;  // Set loading state (if needed)

      await this.fetchProducts();  // Wait for fetchProducts() to complete
      this.getDatePart();  // Now it's safe to proceed

      // this.checkSingleBatchActivation();  // This runs with fully loaded products

      this.TotalRows = this.products.length;
      this.isBusy = false;  // End loading state
    },
    getDatePart() {
      let today = new Date();
      this.date_today = today;
    },

    // switchLoaders(){
    //   if(this)
    //   return(this.loader)
    // },

    exportData() {
      return this.products.map(product => ({
        name: product.name,
        category: product.category.name, // Accessing category name
        bar_code: product.bar_code || '', // Include this field if available
        active_batch: product.active_batch || '', // Ensure this field exists in your product data
        active_quantity: product.active_quantity || '', // Ensure this field exists in your product data
        min_quantity: product.min_quantity || '', // Ensure this field exists in your product data

        // Format quantities with each batch and expiry date on a new line
        quantities: product.quantities.map(quantity =>
          `Batch: ${quantity.batch}, Quantity: ${quantity.quantity}, Buy Price: UGX. ${quantity.buying_price}, Expiry Date: ${quantity.expiry_date || 'N/A'}, Sold QTY: ${quantity.sold_quantity}`
        ).join('\n'),

        // Format units with each unit detail on a new line
        units: product.units.length > 0
          ? product.units.map(unit => {
            // Find the unit name corresponding to the unit_id in the unit_name array
            const unitDetails = product.unit_name.find(u => u.unit_id === unit.unit_id) || {};
            return `Unit Name: ${unitDetails.unit_name || 'N/A'}, Selling Price: UGX. ${unit.selling_price || 'N/A'}, Buying Price: UGX. ${unit.buying_price || 0}`;
          }).join('\n')
          : 'No Units Available',
        addedby: product.addedby || '', // Ensure this field exists in your product data
        addedon: product.addedon || '', // Ensure this field exists in your product data

      }));
    },

    // checkSingleBatchActivation() {
    //   this.products.forEach(product => {
    //     if (product.quantities.length === 1 && product.quantities[0].active !== 1) {
    //       // If there's only one batch and it's not already active, activate it
    //       this.activateBatch(product.id, product.name, product.quantities[0].id);
    //     }
    //   });
    // },

    async activateBatch(product_id, quantity_id) {
      this.loader = true
      let obj = {
        product: product_id,
        quantity: quantity_id,
      };

      let url = "activate_batch";
      await axios.post(url, obj);
      await this.fetchProducts();
      this.loader = false
    },


    ...productMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>
